<template>
  <div class="board" @click="handle2Active">
    <div class="bg">
      <p>将于 {{ item.time.day }}天{{ item.time.hour }}小时{{ item.time.minute }}分钟后 开播</p>
      <img src="@/assets/image/home/content_icon_live2x.png" alt="" />
    </div>
    <div class="live-info">
      <div class="title van-ellipsis">{{ item.event_name }}</div>
      <div class="time">
        <span>{{ item.event_date }}</span>
        <span>{{ item.start_time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  methods: {
    handle2Active() {
      this.$router.push(`/play/${this.item.event_info_id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.board {
  width: 164px;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 14px;
}
.bg {
  overflow: hidden;
  width: 100%;
  height: 92px;
  position: relative;
  background: rgba(174, 194, 251, 1);
  p {
    position: absolute;
    top: 40%;
    width: 100%;
    transform: translateY(-50%);
    color: #fff;
    font-size: 12px;
    text-align: center;
  }
  img {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 40px;
  }
}
.live-info {
  padding: 6px;
  .title {
    color: #303133;
    font-weight: 500;
    font-size: 14px;
    line-height: 2;
  }
  .time {
    color: #909399;
    font-size: 12px;
  }
  .time span:nth-child(2) {
    margin-left: 10px;
  }
}
</style>
